import React from "react";
import dateDisplay from "./../../common/dateDisplay";
import { convertFromUTC } from "../../../util/convert_timezone";
import ReactGA from "react-ga4";
import _ from "lodash";
import { ViewJob } from "./displayJob";
import { Component } from "react";
import vehicleImage from "../../../assets/LogoTest.png";
import { getDisplayDates, formatDisplayDate } from "../../../util/dateDisplayUtils"
import ImageGalleryModal from "../../partial/ImageGalleryModal";
import "../../partial/ImageGalleryModal.css";

require("dotenv").config();

class Requestimate extends Component {
  state = {
    showDetails: false,
    showImageGallery: false,
  };

  isEmpty = (obj) => {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  };

  displayDetails = () => {
    this.setState({ showDetails: true });
  };

  addCustomClose = () => {
    this.setState({ showDetails: false });
  };

  handleImageCardClick = () => {
    if (this.props.vehicleImages && this.props.vehicleImages.length > 0) {
      this.setState({ showImageGallery: true });
    }
  };

  closeImageGallery = () => {
    this.setState({ showImageGallery: false });
  };

  render() {
  // Detect if mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const getDepositStatusBadge = (status) => {
  switch(status) {
    case 'paid': return 'badge-success';
    case 'pending': return 'badge-warning';
    case 'invoiced': return 'badge-info';
    default: return 'badge-secondary';
  }
};
  
    if (this.props.userType === "dealer") {
      if (this.props.mode === "jobs") {
        ReactGA.send({ hitType: "pageview", page: "/dealerJobDetail" });
      } else {
        ReactGA.send({ hitType: "pageview", page: "/dealerRequestDetail" });
      }
    }
    if (this.props.userType === "installer") {
      if (this.props.mode === "jobs") {
        ReactGA.send({ hitType: "pageview", page: "/installerJobDetail" });
      } else {
        ReactGA.send({ hitType: "pageview", page: "/installerRequestDetail" });
      }
    }
    // const message = "To view more detail of a " + this.props.mode.slice(0, -1) + ", select one from the list"
    // if nothing selected, selected item isn't in the displayed list, we are done
    if (this.isEmpty(this.props.selectedRequestimate)) {
      return (
        <h5 className="text-center p-3">
          <span></span>
        </h5>
      );
    } else {
      // if something selected, but selected item isn't in the displayed list, we are done
      let check = [];
      check = this.props.displayedList.filter(
        (item) => item.requestId === this.props.selectedRequestimate.requestId
      );
      if (check.length === 0) {
        return (
          <h5 className="text-center p-3">
            <span></span>
          </h5>
        );
      } else {
        const divStyle = {
          backgroundColor: "#FFD9AC",
        };
        if (this.props.mode === "jobs") {
          divStyle.backgroundColor = "#98CBE5";
        }

        const request = this.props.selectedRequestimate;
        const installer = this.props.installer;

        const displayDates = getDisplayDates(
            request,
            this.props.calendarDays,
            this.props.userType
        );

        var displayTotal = (request.requestTotal - (request.requestDiscount || 0)) + (request.requestTaxes || 0);

        // Set up the map components
        var displayLat = request.latitude;
        var displayLong = request.longitude;
        var displayName = request.dealerName;
        if (this.props.userType === "dealer" && request.assignedTo) {
          displayName = installer.Installer_Name;
          displayLat = installer.latitude;
          displayLong = installer.longitude;
        }

        var custImage = vehicleImage;
        var displayDest = "";
        if (displayLat != null && displayLat !== 0 && String(displayLat).trim() !== "") {
        custImage =
          "https://maps.googleapis.com/maps/api/staticmap?size=180x150&zoom=15&markers=color:red%7C" +
          displayLat +
          "," +
          displayLong +
          "&key=" +
          process.env.REACT_APP_GOOGLE_API_KEY;
        displayDest =
          "https://www.google.com/maps/search/?api=1&query=" +
          displayLat +
          "," +
          displayLong;

        }

        // Determine which image to display in the vehicle card
        const { vehicleImages } = this.props;
        const hasImages = vehicleImages && vehicleImages.length > 0;
        // Show first image if available, otherwise show Jobvious logo
        const displayImage = hasImages ? (vehicleImages[0].url || vehicleImages[0].photo_url) : vehicleImage;
        const cardClassName = hasImages ? "card m-2 shadow corners vehicle-card-thumbnail" : "card m-2 shadow corners";

        return (
          <React.Fragment>
            {/* Campaign Context Banner - Shows when estimate came from a campaign */}
            {request.campaign_id && (
              <div className="alert mb-3" style={{
                backgroundColor: '#e7f3ff',
                border: '1px solid #b6d4fe',
                borderRadius: '8px',
                padding: '12px 15px'
              }}>
                <div className="d-flex align-items-start">
                  <div className="mr-3">
                    <i className="fa fa-bullhorn fa-lg" style={{ color: '#0c5460' }}></i>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1" style={{ color: '#0c5460' }}>
                      <strong>Campaign Lead</strong>
                      {request.promo_code && (
                        <span className="badge badge-success ml-2" style={{ fontSize: '11px' }}>
                          {request.promo_code}
                        </span>
                      )}
                    </h6>
                    {request.campaign_name && (
                      <p className="mb-1" style={{ color: '#495057', fontSize: '14px' }}>
                        <strong>Campaign:</strong> {request.campaign_name}
                      </p>
                    )}
                    {request.campaign_description && (
                      <p className="mb-1" style={{ color: '#495057', fontSize: '13px', fontStyle: 'italic' }}>
                        "{request.campaign_description}"
                      </p>
                    )}
                    {request.discount_description && (
                      <p className="mb-0" style={{ color: '#155724', fontSize: '14px' }}>
                        <i className="fa fa-tag mr-1"></i>
                        <strong>Offer:</strong> {request.discount_description}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="card-group corners">
              <div className={cardClassName} onClick={hasImages ? this.handleImageCardClick : null}>
                <img className="card-img" src={displayImage} alt="" />
                <div className="card-image-overlay">
                  <p className="text-center">
                    {request.vehicleYear} {_.upperCase(request.vehicleMake)}{" "}
                    {_.upperCase(request.vehicleModel)}
                  </p>
                  <p className="text-center">
                    {_.upperCase(request.vehicleTrim)}
                  </p>
                </div>
                {hasImages && (
                  <div className="photo-count-badge">
                    <i className="fa-solid fa-camera"></i>
                    {vehicleImages.length}
                  </div>
                )}
              </div>
              
              <div className="card m-2 shadow corners">
                <div className="card-body">

                  {/*<div className="row">
                    <div className="col text-center">
                      {dateDisplay(
                        convertFromUTC(request.availableDate).format(
                          "MMMM D, YYYY"
                        )
                      )}
                    </div>
                    <div className="col text-center">
                      {request.requestType === "installer"
                        ? dateDisplay(
                            convertFromUTC(this.props.offers[0].endDate).format(
                              "MMMM D, YYYY"
                            )
                          )
                        : dateDisplay(
                            convertFromUTC(request.dueDate).format(
                              "MMMM D, YYYY"
                            )
                          )}
                    </div>
                  </div> */}

              <div className="row">
                <div className="col text-center">
                  <small className="text-muted">{displayDates.startLabel}</small>
                  <div>
                    {dateDisplay(displayDates.startDate)}
                  </div>
                </div>
                <div className="col text-center">
                  <small className="text-muted">{displayDates.endLabel}</small>
                  <div>
                    {dateDisplay(displayDates.endDate)}
                  </div>
                </div>
              </div>
 
                  <div className="row u-2">
                    <div className="col text-center">
                      {request.serviceRequested}
                      {/* Enhanced deposit indicator with status */}
                      {request.depositAmount > 0 && (
                        <div className="deposit-indicator mt-2">
                          <span className={`badge ${request.depositIsPaid ? 'badge-success' : 'badge-info'}`}>
                            ${request.depositAmount} deposit 
                            {request.depositIsPaid === 1 && " Paid"}
                          </span>
                        </div>
                      )}                    
                      </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <h4>
                        {isNaN(displayTotal)
                          ? "$0.00"
                          : "$" + displayTotal.toFixed(2)}
                      </h4>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      {request.requestType === "installer"
                        ? "incl. Sales Tax"
                        : ""}
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col">
                      <button
                        className="btn-sm btn-success m-2 buttons"
                        onClick={this.displayDetails}
                      >
                        Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-2 shadow corners">
                {request.longitude ? (
                  <a href={displayDest} target="_blank">
                    <img
                      className="card-img"
                      src={custImage}
                      alt=""
                      onClick={() => displayDest}
                    />
                  </a>
                ) : (
                  <img className="card-img" src={custImage} alt="" />
                )}
                <div className="card-image-overlay corners">
                  <p className="card-text text-center">
                    {displayName}
                    <br />
                    {request.email}
                    <br />
                    {request.phone_number}{" "}
                  </p>
                </div>
              </div>
              <ViewJob
                show={this.state.showDetails}
                onHide={this.addCustomClose}
                request={this.props.selectedRequestimate}
                services={this.props.services}
                notes={this.props.notes}
                calendarDays={this.props.calendarDays}
                userType={this.props.userType}
              />
              <ImageGalleryModal
                show={this.state.showImageGallery}
                onHide={this.closeImageGallery}
                images={vehicleImages || []}
                title="Vehicle Photos"
              />
            </div>
          </React.Fragment>
        );
      }
    }
  }
}



export default Requestimate;
